import { render, staticRenderFns } from "./AiWidget.vue?vue&type=template&id=73edf7a0&scoped=true"
import script from "./AiWidget.vue?vue&type=script&lang=js"
export * from "./AiWidget.vue?vue&type=script&lang=js"
import style0 from "./AiWidget.vue?vue&type=style&index=0&id=73edf7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73edf7a0",
  null
  
)

export default component.exports